import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

import { FieldType } from '@ngx-formly/core';

import { SelectionCardInterface } from '@valk-nx/components/ui-selection-card/src/lib/selection-card.interface';

@Component({
	selector: 'formly-field-selection-card',
	template: `
		<div [attr.data-test-id]="field.id">
			<vp-selection-card
				[controlType]="props['controlType'] ?? 'radio'"
				[customFormControl]="selectionCardFormControl"
				[grid]="props['grid']"
				[hasCardsAsMarkdown]="props['cardsAsMarkdown']"
				[hasError]="showError"
				[isDisabled]="props.disabled"
				[isReadonly]="props.readonly"
				[isValid]="formControl.valid && formControl.touched"
				[name]="field.key.toString()"
				[(options)]="selectionCardOptions"
				ngDefaultControl
			/>
		</div>
	`,
	standalone: false,
})
export class SelectionCardComponent extends FieldType implements OnInit {
	selectionCardOptions: SelectionCardInterface[];
	selectionCardFormControl: FormControl;

	ngOnInit() {
		this.selectionCardOptions = this.props[
			'options'
		] as SelectionCardInterface[];

		this.selectionCardFormControl = this.formControl as FormControl;
	}
}
